import { Box, Text } from "@chakra-ui/react";
import { TextGray } from "./TextGray";

type Props = {
  label: string;
  value: string;
};

export const TextWithLabel = ({ label, value }: Props) => {
  return (
    <Box lineHeight={1.3}>
      <Text fontSize="md" fontWeight="medium">
        {value}
      </Text>
      <TextGray fontSize="sm" fontWeight="thin">
        {label}
      </TextGray>
    </Box>
  );
};
